module.exports = __webpack_public_path__ + "img/a3.5e7cd005.svg";